import React from 'react';
import { Tag } from '../design-system';

const TONE = {
  healthy:   'success',
  active:    'success',
  degraded:  'warning',
  suspended: 'error',
  down:      'error',
  error:     'error',
  archived:  'neutral',
  pending:   'neutral',
  stopped:   'neutral',
  provisioning: 'cobalt',
  unknown:   'neutral',
};

function StatusChip({ status }) {
  const key = (status || 'unknown').toLowerCase();
  const tone = TONE[key] || TONE.unknown;
  return (
    <Tag
      tone={tone}
      variant="soft"
      dot
      bullet={false}
      sx={{
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        fontSize: '0.7rem',
      }}
    >
      {key}
    </Tag>
  );
}

export default StatusChip;
